import LoadingOverlay from '@/components/loading/LoadingOverlay';
import AuthLayout from '@/layouts/AuthLayout';
import { useAuthContext } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/const';

const ProtectedAuthRoutes = () => {
  const { isAuthenticated, isLoading, isRefreshing } = useAuthContext();

  if (isLoading || isRefreshing) {
    return <LoadingOverlay />;
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.dashboard} replace />;
  }

  return <AuthLayout />;
};

export default ProtectedAuthRoutes;
